// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorCoverageMedicalCoverageMedicalCoverageRequest {
    static getAttributeTypeMap() {
        return PayorCoverageMedicalCoverageMedicalCoverageRequest.attributeTypeMap;
    }
}
PayorCoverageMedicalCoverageMedicalCoverageRequest.discriminator = undefined;
PayorCoverageMedicalCoverageMedicalCoverageRequest.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    }
];
//# sourceMappingURL=payorCoverageMedicalCoverageMedicalCoverageRequest.js.map